module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/017-christmas-island-1420be559897b726304b64a69a68b2d2.svg";